import React from 'react';
import cx from 'classnames';
import _isEmpty from 'lodash.isempty';
import AssetPreview from '../../AssetPreview';
import '../styles/_voice-over-preview.scss';
import DefaultThumbnail from './components/DefaultThumbnail';













function VoiceOverPreview({
  className = '',
  asset,
  customThumbnail,
  thumbnailWidth = 100,
  thumbnailHeight = 100,
  defaultThumbnail = null,
  defaultThumbnailIconName = 'image',
  defaultThumbnailIconSize = 24,
  defaultThumbnailIconColor = 'nevada'
}) {
  const restProps = {
    canPlayAudio: true,
    canPlayVideo: true,
    width: thumbnailWidth,
    height: thumbnailHeight
  };

  return (
    <div
      className={cx('voice-over-preview', className)}
      style={{
        width: thumbnailWidth,
        height: thumbnailHeight
      }}>

      {_isEmpty(asset) && _isEmpty(customThumbnail) ?
      <div className="voice-over-preview__default-thumbnail">
          <DefaultThumbnail
          defaultThumbnail={defaultThumbnail}
          defaultThumbnailIconName={defaultThumbnailIconName}
          defaultThumbnailIconSize={defaultThumbnailIconSize}
          defaultThumbnailIconColor={defaultThumbnailIconColor} />

        </div> :

      <AssetPreview
        asset={!_isEmpty(asset) ? asset : customThumbnail}
        audioThumbnail={!_isEmpty(customThumbnail) ? customThumbnail : null}
        defaultAudioThumbnail={_isEmpty(customThumbnail) || _isEmpty(asset) ?
        <DefaultThumbnail
          defaultThumbnail={defaultThumbnail}
          defaultThumbnailIconName={defaultThumbnailIconName}
          defaultThumbnailIconSize={defaultThumbnailIconSize}
          defaultThumbnailIconColor={defaultThumbnailIconColor} /> :

        null}
        hideFileTypeIcon
        {...restProps} />}


    </div>);

}

export default VoiceOverPreview;